"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBonus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.573 2.24C5.833.93 5.25.658 4.824 1.424c-.426.765-1.606 3.1-3.537 7.002-.464.69-.365 1.241.297 1.653.187 1.628.351 5.12 4.989 5.12 3.092 0 4.485-1.965 4.18-5.895.002-.585.427-.878 1.274-.878M1 8.562c3.73-.75 7.063-.75 10 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.454 2.24c.74-1.31 1.322-1.582 1.749-.816.426.765 1.606 3.1 3.537 7.002.464.69.365 1.241-.297 1.653-.187 1.628-.351 5.12-4.989 5.12-3.092 0-4.485-1.965-4.18-5.895-.002-.585-.427-.878-1.274-.878m11 .136c-3.73-.75-7.063-.75-10 0"
  })));
}

var MemoSvgBonus = /*#__PURE__*/React.memo(SvgBonus);
var _default = MemoSvgBonus;
exports["default"] = _default;